import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import { createClient } from "../../utils/supbase/client";
import MobileApp from "../../components/mobile-app";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";
import ScrollToTop from "../../components/scroll-to-top";
import {
  useDeleteAllItemsMutation,
  useDeleteItemMutation,
  useGetCartItemsQuery,
  useUpdateItemMutation,
} from "../../redux/services/cart";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { orderBillingValidationSchema } from "../../utils/resolvers";
import { useAddOrderMutation } from "../../redux/services/orders";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";

export default function ShopCheckOut() {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [addOrder] = useAddOrderMutation();
  const [totalPrice, setTotalPrice] = useState();
  const [productDetails, setProductDetails] = useState();
  const [isloading, setIsLoading] = useState(false);

  const { data, isLoading } = useGetCartItemsQuery({
    filter: { user_id: user.id },
  });

  const [deleteAllItems, { data: deletedItem }] = useDeleteAllItemsMutation();
  const supabase = createClient();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: orderBillingValidationSchema,
    defaultValues: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      address: "",
      country: "",
      state: "",
      zipcode: "",
    },
  });

  useEffect(() => {
    setTotalPrice(
      data?.reduce((total, item) => {
        const price = item.product.sale_price ?? item.product.price;
        return total + price * item.quantity;
      }, 0)
    );

    setProductDetails(
      data?.map((item) => ({
        product_id: item.product.id,
        product_name: item.product.title,
        product_price: item.product.sale_price ?? item.product.price,
        quantity: item.quantity,
      }))
    );
  }, [data]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await addOrder({
        user_id: user?.id,
        order_date: new Date(Date.now()),
        product_details: productDetails,
        total_amount: totalPrice,
        status: "pending",
        name: data.firstName + " " + data.lastName,
        phone: data.phoneNumber,
        email: data.email,
        billing_address: data.address,
        country: data.country,
        state: data.state,
        zip_code: data.zipcode,
        payment_type: "COD",
      });
      console.log("Order added successfully.");

      // deleteAllItems(user.id);
      const { error } = await supabase
        .from("cart")
        .delete()
        .filter("user_id", "eq", user.id);
      if (error) {
        console.error("Error deleting cart items:", error);
      }

      const orderId = response?.data[0]?.id; // Assuming `response.data.id` holds the order ID
      navigate(`/order-confirmation?id=${orderId}`);
    } catch (error) {
      console.error("Error Adding Order: ", error);
    } finally {
      console.log("Order adding completed.");
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar navClass="defaultscroll is-sticky" />
      <section className="relative table w-full py-20 lg:py-24 md:pt-28 bg-gray-50 dark:bg-slate-800">
        <div className="container relative">
          <div className="grid grid-cols-1 mt-14">
            <h3 className="text-3xl leading-normal font-semibold">Fashion</h3>
          </div>

          <div className="relative mt-3">
            <ul className="tracking-[0.5px] mb-0 inline-block">
              <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500">
                <Link to="/">TAS e store</Link>
              </li>
              <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180">
                <i className="mdi mdi-chevron-right"></i>
              </li>
              <li
                className="inline-block uppercase text-[13px] font-bold text-orange-500"
                aria-current="page"
              >
                Checkout
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 gap-6">
            <div className="lg:col-span-8">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800">
                <h3 className="text-xl leading-normal font-semibold">
                  Billing address
                </h3>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                    <div className="lg:col-span-6">
                      <label className="form-label font-semibold">
                        First Name : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="First Name"
                        name="firstName"
                        {...register("firstName")}
                      />
                      {errors.firstName && (
                        <span className="text-red-600">
                          {errors.firstName.message}
                        </span>
                      )}
                    </div>

                    <div className="lg:col-span-6">
                      <label className="form-label font-semibold">
                        Last Name : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Last Name"
                        name="lastName"
                        {...register("lastName")}
                      />
                      {errors.lastName && (
                        <span className="text-red-600">
                          {errors.lastName.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="lg:col-span-6">
                      <label className="form-label font-semibold">
                        Username
                      </label>
                      <div className="relative mt-2">
                        <span
                          className="absolute top-0.5 start-0.5 w-9 h-9 text-xl bg-gray-100 dark:bg-slate-800 inline-flex justify-center items-center text-dark dark:text-white rounded"
                          id="basic-addon1"
                        >
                          <i className="mdi mdi-at"></i>
                        </span>
                        <input
                          type="text"
                          className="ps-12 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="Username"
                          required
                        />
                      </div>
                    </div> */}

                    <div className="lg:col-span-6">
                      <label className="form-label font-semibold">
                        Phone Number : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Phone Number"
                        name="phoneNumber"
                        {...register("phoneNumber")}
                      />
                      {errors.phoneNumber && (
                        <span className="text-red-600">
                          {errors.phoneNumber.message}
                        </span>
                      )}
                    </div>
                    <div className="lg:col-span-6">
                      <label className="form-label font-semibold">
                        Your Email : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="email"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Email"
                        name="email"
                        {...register("email")}
                      />
                      {errors.email && (
                        <span className="text-red-600">
                          {errors.email.message}
                        </span>
                      )}
                    </div>

                    <div className="lg:col-span-12">
                      <label className="form-label font-semibold">
                        Address : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Address"
                        name="address"
                        {...register("address")}
                      />
                      {errors.address && (
                        <span className="text-red-600">
                          {errors.address.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="lg:col-span-12">
                      <label className="form-label font-semibold">
                        Address 2 :{" "}
                      </label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Address:"
                        id="address"
                        name="name"
                        required=""
                      />
                    </div> */}

                    <div className="lg:col-span-4">
                      <label className="font-semibold">Country:</label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Country"
                        name="country"
                        {...register("country")}
                      />
                      {errors.country && (
                        <span className="text-red-600">
                          {errors.country.message}
                        </span>
                      )}
                    </div>

                    <div className="lg:col-span-4">
                      <label className="font-semibold">State:</label>
                      <input
                        type="text"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="State"
                        name="state"
                        {...register("state")}
                      />
                      {errors.state && (
                        <span className="text-red-600">
                          {errors.state.message}
                        </span>
                      )}
                    </div>

                    <div className="lg:col-span-4">
                      <label className="form-label font-semibold">
                        Zip Code : <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="number"
                        className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                        placeholder="Zip"
                        name="zipcode"
                        {...register("zipcode")}
                      />
                      {errors.zipcode && (
                        <span className="text-red-600">
                          {errors.zipcode.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="lg:col-span-12">
                      <div className="flex items-center w-full mb-0">
                        <input
                          className="form-checkbox rounded border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                          type="checkbox"
                          value=""
                          id="sameaddress"
                        />
                        <label
                          className="form-check-label text-slate-400"
                          htmlFor="sameaddress"
                        >
                          Shipping address is the same as my billing address
                        </label>
                      </div>

                      <div className="flex items-center w-full mb-0">
                        <input
                          className="form-checkbox rounded border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                          type="checkbox"
                          value=""
                          id="savenexttime"
                        />
                        <label
                          className="form-check-label text-slate-400"
                          htmlFor="savenexttime"
                        >
                          Save this information for next time
                        </label>
                      </div>
                    </div> */}
                  </div>

                  <h3 className="text-xl leading-normal font-semibold mt-6">
                    Payment
                  </h3>

                  {/* <form> */}
                  <div>
                    <div className="grid lg:grid-cols-12 grid-cols-1 mt-6 gap-5">
                      <div className="lg:col-span-12">
                        <div className="block">
                          <div>
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                className="form-radio border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                                name="radio-colors"
                                value="1"
                                readOnly
                                defaultChecked
                              />
                              <span className="text-slate-400">
                                Cash on Delivery (COD)
                              </span>
                            </label>
                          </div>
                        </div>

                        {/* <div className="block mt-2">
                          <div>
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                className="form-radio border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                                name="radio-colors"
                                value="1"
                                readOnly
                              />
                              <span className="text-slate-400">Debit Card</span>
                            </label>
                          </div>
                        </div>

                        <div className="block mt-2">
                          <div>
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                className="form-radio border-gray-100 dark:border-gray-800 text-orange-500 focus:border-orange-300 focus:ring focus:ring-offset-0 focus:ring-orange-200 focus:ring-opacity-50 me-2"
                                name="radio-colors"
                                value="1"
                                readOnly
                              />
                              <span className="text-slate-400">PayPal</span>
                            </label>
                          </div>
                        </div> */}
                      </div>

                      {/* <div className="lg:col-span-6">
                        <label className="form-label font-semibold">
                          Account Holder Name :{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                          placeholder="Name:"
                          id="accountname"
                          name="name"
                          required=""
                        />
                      </div>

                      <div className="lg:col-span-6">
                        <label className="form-label font-semibold">
                          Credit card number :{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="number"
                          className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                          placeholder="**** **** **** ****"
                          id="cardnumber"
                          name="number"
                          required=""
                        />
                      </div>

                      <div className="lg:col-span-3">
                        <label className="form-label font-semibold">
                          Expiration : <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="number"
                          className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                          placeholder=""
                          id="expiration"
                          name="number"
                          required=""
                        />
                      </div>

                      <div className="lg:col-span-3">
                        <label className="form-label font-semibold">
                          CVV : <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="number"
                          className="w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0 mt-2"
                          placeholder=""
                          id="cvv"
                          name="number"
                          required=""
                        />
                      </div> */}
                    </div>
                  </div>
                  {/* </form> */}
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-orange-500 text-white rounded-md w-full"
                    >
                      {isloading ? (
                        <Loader height="h-5" width="w-5" color="#ffffff" />
                      ) : (
                        "Confirm order"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="p-6 rounded-md shadow dark:shadow-gray-800">
                <div className="flex justify-between items-center">
                  <h5 className="text-lg font-semibold">Your Cart</h5>

                  <Link
                    to="#"
                    className="bg-orange-500 flex justify-center items-center text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full h-5"
                  >
                    {data?.length}
                  </Link>
                </div>

                <div className="mt-4 rounded-md shadow dark:shadow-gray-800">
                  {data?.map((item, index) => {
                    return (
                      <div
                        className="p-3 flex justify-between items-center"
                        key={index}
                      >
                        <div>
                          <h5 className="font-semibold">
                            {item.product.title}
                          </h5>
                          {/* <p className="text-sm text-slate-400">
                            Brief description
                          </p> */}
                        </div>

                        <p className="text-slate-400 font-semibold">
                          {" "}
                          $ {item.product.sale_price ?? item.product.price}{" "}
                        </p>
                      </div>
                      /* <div className="p-3 flex justify-between items-center border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-slate-800 text-green-600">
                        <div>
                          <h5 className="font-semibold">Promo code</h5>
                          <p className="text-sm text-green-600">EXAMPLECODE</p>
                        </div>

                        <p className="text-red-600 font-semibold">-$ 10</p>
                      </div> */
                    );
                  })}
                  <div className="p-3 flex justify-between items-center border border-gray-100 dark:border-gray-800">
                    <div>
                      <h5 className="font-semibold">Total (USD)</h5>
                    </div>

                    <p className="font-semibold">$ {totalPrice}</p>
                  </div>
                </div>

                {/* <div className="subcribe-form mt-6">
                  <div className="relative max-w-xl">
                    <input
                      type="email"
                      id="subcribe"
                      name="email"
                      className="py-4 pe-40 ps-6 w-full h-[50px] outline-none text-black dark:text-white rounded-full bg-white dark:bg-slate-900 shadow dark:shadow-gray-800"
                      placeholder="Promo code"
                    />
                    <button
                      type="submit"
                      className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center absolute top-[2px] end-[3px] h-[46px] bg-orange-500 text-white rounded-full"
                    >
                      Redeem
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* <MobileApp /> */}
      </section>
      <Footer />
      {/* <Switcher /> */}
      <ScrollToTop />
    </>
  );
}
